// src/components/PurchaseFormModal.js
import React, { useState, useEffect } from 'react';
import './PurchaseFormModal.css';
import { API_URL } from "../config";

function PurchaseFormModal({ orderId, initialNrRef, onClose, onSave }) {
    const [nrRef, setNrRef] = useState(initialNrRef || '');
    const [tytulZamowienia, setTytulZamowienia] = useState('');
    const [opisZamowienia, setOpisZamowienia] = useState('');
    const [terminRealizacji, setTerminRealizacji] = useState('');
    const [cena, setCena] = useState('');
    const [nrRefError, setNrRefError] = useState('');
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        if (orderId && !initialNrRef) {
            fetchOrderNrRef(orderId);
        }
    }, [orderId, initialNrRef]);

    const fetchOrderNrRef = async (id) => {
        try {
            const response = await fetch(`${API_URL}/orders/${id}`, {
                credentials: 'include',
            });
            const data = await response.json();
            setNrRef(data.nr_ref);
        } catch (error) {
            console.error('Błąd pobierania nr_ref:', error);
        }
    };

    const validateNrRef = async () => {
        if (!nrRef) {
            setNrRefError('Numer zlecenia jest wymagany.');
            return false;
        }
        try {
            const encodedNrRef = encodeURIComponent(nrRef);
            const response = await fetch(`${API_URL}/purchases/verify?nr_ref=${encodedNrRef}`, {
                credentials: 'include',
            });
            if (!response.ok) {
                throw new Error(`Błąd weryfikacji numeru zlecenia: ${response.status}`);
            }
            const data = await response.json();
            if (!data.exists) {
                setNrRefError('Nie ma takiego zlecenia.');
                return false;
            }
            setNrRefError('');
            return data.id;
        } catch (error) {
            setError(`Błąd weryfikacji numeru zlecenia: ${error.message}`);
            return false;
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        setError('');

        const order_id = initialNrRef ? orderId : await validateNrRef();
        if (!order_id) {
            setLoading(false);
            return;
        }

        if (!tytulZamowienia || tytulZamowienia.length > 60) {
            setError('Tytuł zamówienia jest wymagany i może mieć max 60 znaków.');
            setLoading(false);
            return;
        }

        if (!terminRealizacji) {
            setError('Termin realizacji jest wymagany.');
            setLoading(false);
            return;
        }

        const purchaseData = {
            order_id,
            tytul_zamowienia: tytulZamowienia,
            opis_zamowienia: opisZamowienia,
            termin_realizacji: terminRealizacji,
            cena: cena || null,
        };

        try {
            const response = await fetch(`${API_URL}/purchases`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                credentials: 'include',
                body: JSON.stringify(purchaseData),
            });
            if (!response.ok) throw new Error('Błąd tworzenia zamówienia.');
            const newPurchase = await response.json();
            onSave(newPurchase);
            onClose();
        } catch (error) {
            setError('Wystąpił błąd podczas składania zamówienia.');
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="modal-overlay">
            <div className="modal">
                <h3>Złóż Zamówienie</h3>
                {error && <p className="error-message">{error}</p>}
                <form onSubmit={handleSubmit}>
                    <div className="form-group">
                        <label>Nr. Zlecenia:</label>
                        <input
                            type="text"
                            value={nrRef}
                            onChange={(e) => setNrRef(e.target.value)}
                            disabled={!!initialNrRef}
                            placeholder="np. 0001/2025"
                            required
                        />
                        {nrRefError && <p className="error-message">{nrRefError}</p>}
                    </div>
                    <div className="form-group">
                        <label>Tytuł Zamówienia:</label>
                        <input
                            type="text"
                            value={tytulZamowienia}
                            onChange={(e) => setTytulZamowienia(e.target.value)}
                            maxLength="60"
                            required
                        />
                    </div>
                    <div className="form-group">
                        <label>Opis Zamówienia:</label>
                        <textarea
                            value={opisZamowienia}
                            onChange={(e) => setOpisZamowienia(e.target.value)}
                        />
                    </div>
                    <div className="form-group">
                        <label>Termin Realizacji:</label>
                        <input
                            type="date"
                            value={terminRealizacji}
                            onChange={(e) => setTerminRealizacji(e.target.value)}
                            min={new Date().toISOString().split('T')[0]}
                            required
                        />
                    </div>
                    <div className="form-group">
                        <label>Cena:</label>
                        <input
                            type="number"
                            step="0.01"
                            value={cena}
                            onChange={(e) => setCena(e.target.value)}
                            placeholder="np. 269.90"
                        />
                    </div>
					<div className="modal-buttons">
						<button type="submit" className="btn-primary" disabled={loading}>
							{loading ? 'Wysyłanie...' : 'Akceptuj'}
						</button>
						<button type="button" className="btn-secondary" onClick={onClose} disabled={loading}>
							Anuluj
						</button>
					</div>
                </form>
            </div>
        </div>
    );
}

export default PurchaseFormModal;